
import { ref, computed, defineProps } from "vue";
import { ImagePreview } from "vant";
export default {
  props: {
    item: {
      type: Object,
      default: {},
    },
    comment:{
      type:Boolean,
      default:false
    }
  },
  setup(props: any) {
    let value = ref(3);
    let arr: any = [];

    const get_avatar_fn = (event: any) => {
      event.currentTarget.setAttribute("src", 'https://image.kilimall.com/global/images/avatar.png'.webpFilters())
    }
    const get_user_info = computed(() => {
      let item = props.item
      if(item && item.extContents) {
        return JSON.parse(item.extContents)
      }
      return {}
    })
    const get_img_url = (item: any) => {
      if(item.mediaType === 2) {
        return item.coverImg
      }
      return item.mediaContents
    }
    let ImagePreviews = (item: any,index:number) => {
      arr = [];
      item.commentMediaFullList.forEach((e: any) => {
        arr.push(get_img_url(e));
      });
      ImagePreview(
        {
          images:[...arr],
           startPosition:index,
        }
      );
    };
    /**
     * 英文日期
     */
    const get_data_str_fn = (date: number) => {
      return common.get_data_str_fn(date)
    }
    return {
      value,
      ImagePreviews,
      get_img_url,
      get_user_info,
      get_avatar_fn,
      get_data_str_fn
    };
  },
};
